module.exports = __webpack_public_path__ + "img/intro01.5a00208c.png";